import { render } from "./CampaignsChart.vue?vue&type=template&id=d00b80e2&ts=true"
import script from "./CampaignsChart.vue?vue&type=script&lang=ts"
export * from "./CampaignsChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__